import React from 'react';

import Switch from 'antd/es/switch';

import { Feature } from '@commonTuna/react/objects/CompanyFeature';

import { ReceivedValue } from '@app/components/Pages/Admin/Reports/Base/BaseReport';
import { OrderTargetType, PaymentType } from '@app/objects/Order';
import { useCompanyFeatureProviderContext } from '@app/components/UI/CompanyFeaturesSetter/CompanyFeaturesSetter';

interface Params {
	receivedValue: ReceivedValue;
	orderTargetTypes: Array<OrderTargetType>;
	paymentTypes: Array<PaymentType>;
	doctorIds: undefined;
	patientId: undefined;
}

interface ComponentProps {
	checked: boolean;
	handleChange: (params: Params) => void;
	style?: any;
	className?: string;
}

const AccrualSwitcher: React.FC<ComponentProps> = ({
	checked,
	handleChange,
	style,
	className = 'accrual-switch',
}) => {
	const { checkFeatureAccess } = useCompanyFeatureProviderContext();
	const allowGiftCard = checkFeatureAccess(Feature.GiftCard);
	return (
		<>
			<Switch
				className={className}
				title={checked
					? '$ value type: services, products, and parts of specials provided'
					: '$ value type: money paid, incl prepayments less refunds'}
				checked={checked}
				style={{
					backgroundColor: !checked ? 'green' : undefined,
					...style,
				}}
				onClick={(checked) => {
					handleChange({
						receivedValue: checked ? ReceivedValue.Accrual : ReceivedValue.PaymentsBased,
						orderTargetTypes: [
							OrderTargetType.Service,
							OrderTargetType.Product,
							OrderTargetType.Special,
							OrderTargetType.Deposit,
							OrderTargetType.Tip,
							OrderTargetType.Credit,
						].filter((value) => value !== OrderTargetType.Deposit || !checked),
						paymentTypes: checked
							? allowGiftCard
								? [
									PaymentType.Cash,
									PaymentType.CreditCard,
									PaymentType.DebitCard,
									PaymentType.Check,
									PaymentType.ElectronicPayment,
									PaymentType.Credit,
									PaymentType.NoPayments,
									PaymentType.GiftCard,
									PaymentType.Balance,
								] : [
									PaymentType.Cash,
									PaymentType.CreditCard,
									PaymentType.DebitCard,
									PaymentType.Check,
									PaymentType.ElectronicPayment,
									PaymentType.Credit,
									PaymentType.NoPayments,
									PaymentType.Balance,
								]
							: [
								PaymentType.Cash,
								PaymentType.CreditCard,
								PaymentType.DebitCard,
								PaymentType.Check,
								PaymentType.ElectronicPayment,
								PaymentType.Credit,
							],
						doctorIds: undefined,
						patientId: undefined,
					});
				}}
				unCheckedChildren={<>
					<i className="fa fa-dollar" />
					&nbsp;Received
				</>}
				checkedChildren={<>
					<i className="fa fa-dollar" />
					&nbsp;Earned
				</>}
			/>
		</>
	);
};

export default AccrualSwitcher;
